export default {
    user: undefined,
    originalUser: undefined,
    suppliersProducts: {
        loading: false,
        error: false,
        items: undefined
    },
    productTypes: [],
    productType: undefined,
    suppliers: [],
    supplier: {
        xmlSupplier: false
    },
    login: {
        loading: false,
        message: null,
        notice: undefined
    },
    forgot: {
        loading: false,
        message: null
    },
    reset: {
        loading: false,
        message: null
    },
    activation: {
        loading: false,
        message: null
    },
    referrer: undefined
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/state.js